var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"favorites"}},[_vm._m(0),_c('questionCard')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleCover"},[_c('div',{staticClass:"title"},[_vm._v("收藏夹")])])
}]

export { render, staticRenderFns }